import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {OrderItemService} from 'app/blocks/service/api/order-item.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IOrderItem} from 'app/blocks/model/order-item.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {OrderItem} from 'app/blocks/model/order-item.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class OrderItemResource extends AbstractEntityResource<IOrderItem> {
    constructor(orderItemService: OrderItemService, router: Router) {
        super(
            Resource.ORDER_ITEMS,
            orderItemService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.ORDER_ITEMS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.ORDER_ITEMS),
            (entity?) => new OrderItem(entity),
            (entity) => entity.code
        );
    }
}
